// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import VueSweetAlert from 'vue-sweetalert'
console.log('sw' , VueSweetAlert);
Vue.use(VueSweetAlert)

import App from '@/components/App'


import router from './router'
import store from './store'


import axios from 'axios';

import moment from 'moment';

console.log(',moment',moment);
console.log(moment().format('MMMM Do YYYY, h:mm:ss a'));
window.axioss = axios;

store.dispatch('log_user');


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js